export const GET_USER_DETAILS = 'GET_USER_DETAILS';
export const UPDATE_REGISTER_FORM = 'UPDATE_REGISTER_FORM';
export const CLEAR_REGISTER_FORM = 'CLEAR_REGISTER_FORM';
export const UPDATE_TERMS_SERVICE = 'UPDATE_TERMS_SERVICE';
